import React from 'react'

const LocationIconMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_2496_39973)"
      fill-opacity="0.1"
    />
    <g clip-path="url(#clip0_2496_39973)">
      <path
        d="M17.378 14.0443C17.2701 14.1313 17.1761 14.2009 17.0891 14.274C16.3549 14.876 15.3005 14.7438 14.7437 14.1348C14.6706 14.0548 14.6149 14.0408 14.5349 14.1278C14.3435 14.3401 14.1069 14.4863 13.832 14.5628C13.6615 14.6081 13.484 14.6394 13.2996 14.6777C13.2961 14.6951 13.2926 14.709 13.2926 14.7229C13.2926 15.8678 13.2926 17.0161 13.2926 18.161C13.2926 18.2689 13.3413 18.2932 13.4353 18.2897C13.7728 18.2897 14.1138 18.2897 14.4514 18.2897C14.6463 18.2897 14.6532 18.2828 14.6532 18.0844C14.6532 17.3989 14.6532 16.7099 14.6532 16.0244C14.6532 15.7286 14.8029 15.572 15.0952 15.5685C15.7041 15.5615 16.3131 15.5615 16.9221 15.5685C17.1065 15.5685 17.2701 15.6416 17.3327 15.8295C17.3675 15.9304 17.3675 16.0487 17.371 16.1566C17.371 16.8039 17.371 17.4511 17.371 18.1018C17.371 18.2897 17.3745 18.2932 17.5693 18.2932C17.8895 18.2932 18.2062 18.2932 18.5263 18.2932C18.7212 18.2932 18.7247 18.2932 18.7247 18.1053C18.7247 17.0161 18.7247 15.9304 18.7247 14.8412V14.6637C18.1888 14.6324 17.7329 14.448 17.3884 14.0443H17.378Z"
        fill="#052351"
      />
      <path
        d="M16.0836 6.50008C15.4015 6.58708 14.7021 6.59752 14.0409 6.77151C8.40352 8.23305 5.99198 14.883 9.71542 19.3825C11.3823 21.3939 13.324 23.179 15.1684 25.0442C15.8086 25.688 16.355 25.6428 17.051 24.9572C18.5751 23.4539 20.0993 21.9472 21.5922 20.4125C23.0189 18.944 23.8645 17.1658 24.042 15.1336C24.4317 10.6689 20.7083 6.40265 16.0836 6.50008ZM20.3185 13.2197C20.235 13.5816 20.0715 13.8913 19.8035 14.1453C19.7583 14.1871 19.72 14.2428 19.6678 14.2636C19.4799 14.3437 19.4729 14.4933 19.4729 14.6708C19.4799 15.92 19.4764 17.1693 19.4729 18.4186C19.4729 18.5091 19.4625 18.603 19.4416 18.6935C19.3929 18.8918 19.2467 18.9997 19.0379 18.9997C18.0218 18.9997 17.0022 18.9997 15.9861 18.9997C15.0118 18.9997 14.0339 18.9893 13.0596 19.0067C12.6211 19.0136 12.5202 18.7596 12.5202 18.4569C12.5202 17.6669 12.5202 16.8735 12.5202 16.0836C12.5202 15.5755 12.5202 15.064 12.5202 14.5559C12.5202 14.4481 12.4889 14.3854 12.3984 14.3193C11.9425 13.9818 11.6641 13.5329 11.6572 12.9517C11.6572 12.8299 11.7163 12.7047 11.7651 12.5863C12.0226 11.9321 12.2836 11.2814 12.548 10.6272C12.6489 10.3766 12.7533 10.3105 13.0248 10.3105C14.4271 10.3105 17.74 10.3105 18.951 10.3105C19.2015 10.3105 19.3685 10.401 19.459 10.6446C19.7096 11.2953 19.9671 11.9461 20.2315 12.5933C20.3151 12.7986 20.3707 12.997 20.322 13.2197H20.3185Z"
        fill="#052351"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2496_39973"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0062FF" />
        <stop offset="1" stop-color="#004BC2" />
      </linearGradient>
      <clipPath id="clip0_2496_39973">
        <rect width="16.1396" height="19" fill="white" transform="translate(7.93018 6.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default LocationIconMenu
